export default {
  headingExpressReplacement: {
    id: 'resolution_flow_express_replacement_confirmation_page_heading',
    defaultMessage: 'Express Replacement requested',
  },
  subHeading: {
    id: 'resolution_flow_express_replacement_confirmation_page_sub_heading',
    defaultMessage: 'You’re all set.',
  },
  description: {
    id: 'resolution_flow_express_replacement_confirmation_page_description',
    defaultMessage:
      'Your replacement device will be carefully prepared and sent between {min, date, short} - {max, date, short}. Take a look below for details and next steps.',
  },
  pageTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_title',
    defaultMessage: 'Express replacement requested',
  },
  nextStepsTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_next_steps_title',
    defaultMessage: 'What’s next:',
  },
  replacementStepTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_replacement_step_title',
    defaultMessage: 'Get your replacement device',
  },
  replacementStepDescription: {
    id: 'resolution_flow_express_replacement_confirmation_page_replacement_step_description',
    defaultMessage:
      'Your replacement device will be carefully prepared and sent between {min, date, short} - {max, date, short}.',
  },
  transferStepTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_transfer_step_title',
    defaultMessage: 'Transfer your data',
  },
  transferStepDescription: {
    id: 'resolution_flow_express_replacement_confirmation_page_transfer_step_description',
    defaultMessage:
      'Transfer your data to your replacement device and prep the original for return. More on this later.',
  },
  photosStepTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_photos_step_title',
    defaultMessage: 'Take photos',
  },
  photosStepDescription: {
    id: 'resolution_flow_express_replacement_confirmation_page_photos_step_description',
    defaultMessage:
      'This protects you in case the device is damaged in transit.',
  },
  returnStepTitle: {
    id: 'resolution_flow_express_replacement_confirmation_page_return_step_title',
    defaultMessage: 'Return the original',
  },
  returnStepDescription: {
    id: 'resolution_flow_express_replacement_confirmation_page_return_step_description',
    defaultMessage:
      "We'll send you a return label for the original device. Once you get it, send the device back by {deadline, date, short}.",
  },
  footerCta: {
    id: 'resolution_flow_express_replacement_confirmation_page_footer_cta',
    defaultMessage: 'Learn more about Express Replacement',
  },
}
